
import React, {useMemo, useState} from "react";
import styled from 'styled-components';
import {useSelector} from "react-redux";
import markerBorne from "../images/icons/ic_marker.png";

const Map = styled.div`
    width: 100%;
    height: 100%;
    overflow: hidden;
`;

const positionSrs = 4326;

export const GeoPortailMap = ( props ) => {
    const el = React.useRef(null);
    const mapRef = React.useRef(null);
    const location = useSelector(state => state.config.location);
    let zoom = 17;
    const theme = useSelector((state) => state.config.theme);

    let markerFolder = "default";
    if (theme.geoMarker) markerFolder = theme.geoMarker;

    const center = [location.longitude, location.latitude]
    React.useEffect(() => {
        if (!mapRef.current) {
            const mapElement = el.current;
            if (!mapElement) return;

            const map = mapRef.current = new window.lux.Map({
                target: mapElement,
                bgLayer: 'basemap_2015_global',
                positionSrs: positionSrs,
                zoom: zoom,
                position: center
            });

            map.showMarker({
                positioning: 'center-center',
                iconURL: markerBorne,
                position: center,
                positionSrs: positionSrs,
            });
        }
    });

    React.useEffect(() => {
      const map = mapRef.current;

      return () => {
        if (map) {
          mapRef.current = null;
        }
      };
    }, [mapRef]);

    return (
        <Map
            className = { "geoportailmap" }
            ref = { el }
        />
    );
}

export default GeoPortailMap;